export default __webpack_public_path__ + "static/media/vehicle.39758c03b9d5ab8568143dd57de2831a.svg";